import { APPOINTMENT_STATUS_COLORS } from "@bookdental/schemas";
import { cn } from "@/lib/cn";
import type { WeekAppointment } from "@/lib/dashboard-week";

/** Pílula "Horário - Nome" colorida pelo tipo de procedimento — usada na semana (sempre) e no mês
 *  (quando "Mostrar tudo" está ligado). Clique abre o AppointmentDetailDialog (via onSelect), ou
 *  o resumo cross-org se for de outra organização (ver `organizationId`).
 *
 *  Sem `onSelect` a pílula vira `<span>`: no seletor de dia da Semana ela mora DENTRO do botão do
 *  dia, e botão dentro de botão é HTML inválido — ali ela só mostra a carga, e o clique de verdade
 *  acontece nos cartões abaixo. */
export function AppointmentPill({
  appt,
  onSelect,
}: {
  appt: WeekAppointment;
  onSelect?: (appt: WeekAppointment) => void;
}) {
  const color = appt.color ?? APPOINTMENT_STATUS_COLORS[appt.status];
  const name = appt.patient?.name ?? appt.patientName;
  const isForeign = !!appt.ehDeOutraOrganizacao;
  const label = isForeign
    ? `${appt.startTime} - ${name} (${appt.organizationName})`
    : `${appt.startTime} - ${name}`;

  const classe = cn(
    "block truncate rounded-full px-1.5 py-0.5 text-left text-[10px] font-semibold leading-tight",
    isForeign && "opacity-80 ring-1 ring-dashed ring-zinc-400/50",
  );
  const estilo = { backgroundColor: `${color}1a`, color };

  if (!onSelect) {
    return (
      <span className={classe} style={estilo} title={label}>
        {label}
      </span>
    );
  }

  return (
    <button type="button" onClick={() => onSelect(appt)} className={classe} style={estilo} title={label}>
      {label}
    </button>
  );
}
